import createClient from '../../helpers/api-client';

const storeSuffix = 'Content';

// Actions
export const FETCH_CONTENT_BY_SLUG = `fetchContentBySlugAction${storeSuffix}`;

// Mutations
export const BEGIN_FETCH_CONTENT = `beginFetchContentMutation${storeSuffix}`;
export const RECEIVED_CONTENT = `receivedContentMutation${storeSuffix}`;
export const CONTENT_NOT_FOUND = `contentNotFoundMutation${storeSuffix}`;

// Getters
export const GET_CONTENT = `getContentGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;

export const modelState = () => ({
    content: {
        isLoading: true,
        error: false,
        data: null,
    },
});

export const actions = {
    [FETCH_CONTENT_BY_SLUG]: ({ state, commit }, slug) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_FETCH_CONTENT);

            try {
                const res = await apiClient.get(`/api/page/${slug}`);
                commit(RECEIVED_CONTENT, res);

                resolve(res);
            } catch (error) {
                commit(CONTENT_NOT_FOUND, {
                    error,
                });
                console.log(error);
                resolve(error);
            }
        });
    },
};

export const mutations = {
    [BEGIN_FETCH_CONTENT]: state => {
        state.content.data = null;
        state.content.isLoading = true;
        state.content.error = false;
    },
    [RECEIVED_CONTENT]: (state, payload) => {
        const { data } = payload;
        state.content.isLoading = false;
        state.content.error = false;
        state.content.data = data;
    },
    [CONTENT_NOT_FOUND]: (state, payload) => {
        state.content.isLoading = false;
        state.content.error = true;
    },
};

export const getters = {
    [GET_CONTENT]: state => {
        return state.content.data;
    },
    [IS_LOADING]: state => {
        return state.content.isLoading;
    },
    [GET_ERROR]: state => {
        return state.content.error;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/content-model.js